import { render, staticRenderFns } from "./AntiFraud.vue?vue&type=template&id=7f6a878a&scoped=true&"
import script from "./AntiFraud.vue?vue&type=script&lang=js&"
export * from "./AntiFraud.vue?vue&type=script&lang=js&"
import style0 from "./AntiFraud.vue?vue&type=style&index=0&id=7f6a878a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6a878a",
  null
  
)

export default component.exports